import { PlacesPage } from "../places/PlacesPage";

export function CollectionsPage() {
  return <PlacesPage mode="collections" />;
}

